import { render, staticRenderFns } from "./improvement.vue?vue&type=template&id=120a9950"
import script from "./improvement.vue?vue&type=script&lang=js"
export * from "./improvement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports